<template>
    <div>
        <div class="d-flex" id="content-wrapper">
            <Sidebar :should-render="showBottomBar" />
            <!-- <Mobilebar :should-render="showMobile" @close="closeMobileBar()" /> -->

            <div class="w-100 ml-3">

                <nav id="mainNav" class="navbar navbar-expand-sm  navbar-dark navbar-expand-md  justify-content-left">
                    <a class="navbar-brand" v-if="showLogo"><img class="img-fluid" src="@/assets/logo.png"
                            width="120"></a>
                    <a v-if="!showLogo" class="nav-link click menu-items d-flex align-items-center justify-content-left"
                        href="#" @click="toggleMenu()">
                        <span class="material-icons md-24 mr-1">menu_open</span>
                        hide menu
                    </a>
                    <a v-else class="nav-link click menu-items d-flex align-items-center justify-content-left" href="#"
                        @click="toggleMenu()">
                        <span class="material-icons md-24 mr-1">menu</span>
                        show menu
                    </a>
                    <Dark />
                </nav>
                <nav id="mobileNav" class="navbar navbar-expand-sm  navbar-dark navbar-expand-md  justify-content-left">
                    <a class="navbar-brand"><img class="img-fluid" src="@/assets/logo.png" width="120"></a>
                    <a class="nav-link click menu-items d-flex align-items-center justify-content-left" href="#"
                        @click="toggleMobile()">
                        <span class="material-icons md-24 mr-1">menu</span>
                        show menu
                    </a>
                    <Dark />
                </nav>

                <div class="home container-fuid mb-5 mr-5 ml-5">
                    <div class="row" v-if="displayMessages">
                        <div class="col-md-12 text-center mt-5 mb-5">
                            <transition name="fade">
                                <span class="alert-danger" v-if="showErrorMessage">{{errorMessage}}</span>
                                <span class="alert-success" v-if="showSuccessMessage">{{successMessage}} </span>
                                <span class="alert-info" v-if="showInfoMessage">{{successInfo}}</span>
                            </transition>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">

                        <div class="col-lg-3 col-sm-12 col-md-6 mt-3">

                            <div class="card card-click mt-3 h-100 mb-3" @click="filterBy('opened')">
                                <div class="card-body">
                                    <h2>🚀</h2>
                                    <h1 class="text-center">{{totalEvents}}</h1>
                                    <p class="text-muted text-center">
                                        <small>Opened</small>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-12 col-md-6 mt-3">
                            <div class="card card-click mt-3 h-100 mb-3" @click="filterBy('inRepair')">
                                <div class="card-body">
                                    <h2>🧰</h2>
                                    <h1 class="text-center">{{totalRepair}}</h1>
                                    <p class="text-muted text-center">
                                        <small>In repair</small>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-12 col-md-6 mt-3">
                            <div class="card card-click mt-3 h-100 mb-3" @click="filterBy('closed')">
                                <div class="card-body">
                                    <h2>✅</h2>
                                    <h1 class="text-center">{{totalClosed}}</h1>
                                    <p class="text-muted text-center">
                                        <small>Closed</small>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-12 col-md-6 mt-3">
                            <div class="card mt-3 h-100 mb-3">
                                <div class="card-body">
                                    <i class="fa fa-qrcode fa-2x text-dark"></i>
                                    <p class="text-muted text-center"><small>
                                            <button class="btn btn-dark btn-sm mt-3" @click="openCam()"><i
                                                    class="fa fa-camera-retro"></i> Open scan</button> <br>
                                            Open, scan and see info from mobile on desktop</small>
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row mt-3 mb-3">


                        <div class="col-md-4 mt-3">
                            <div class="card h-100">
                                <div class="card-body">
                                    <h2 class="text-l">🔎</h2>
                                    <h5><strong>Search filters</strong></h5>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="">Company name</label>
                                                <select class="form-control form-control-sm" v-model="sCompany">
                                                    <option value="x" selected>--Select a value--</option>
                                                    <option v-for="(item, index) in sCompanies" :key="index"
                                                        :value="item">{{item}}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label for="">PO/INV</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50"
                                                    v-model.trim="sPo">
                                            </div>
                                            <div class="form-group">
                                                <label for="">Job name</label>
                                                <select class="form-control form-control-sm" v-model="sJob">
                                                    <option value="x" selected>--Select a value--</option>
                                                    <option v-for="(item, index) in sJobs" :key="index" :value="item">
                                                        {{item}}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label for="">S/N</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50"
                                                    v-model="sSn">
                                            </div>
                                            <div class="form-group mb-3">
                                                <vs-button block @click="search()">Search</vs-button>
                                            </div>
                                            <hr />
                                            <p class="text-center">
                                                <a class="click text-center" @click="resetTable()"><i
                                                        class="fas fa-sync-alt"></i> Reset search table</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-8 mt-3">
                            <div class="card h-100">
                                <div class="card-body">
                                    <h2 class="text-l">🎫</h2>
                                    <h5><strong>Register a new ticket</strong></h5>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="">Company Name</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50"
                                                    v-model.trim="companyName">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="">Job name</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50"
                                                    v-model.trim="jobName">
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="">S/N</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50"
                                                    v-model.trim="sn" @keyup="verifySerialNumber"
                                                    v-on:blur="verifySerialNumber()">
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Date</label>
                                                <datetime input-class="form-control form-control-sm" type="datetime"
                                                    format="yyyy-MM-dd HH:mm" :value-zone="timeZ" v-model="sentDate">
                                                </datetime>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Received Date</label>
                                                <datetime input-class="form-control form-control-sm" type="datetime"
                                                    format="yyyy-MM-dd HH:mm" :value-zone="timeZ"
                                                    v-model="receivedDate"></datetime>
                                            </div>
                                        </div>


                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="">Notes</label>
                                                <textarea class="form-control form-control-sm" maxlength="280"
                                                    v-model="sentNotes" cols="30" rows="10"></textarea>
                                                <!-- <vs-textarea maxlength="180" counter="180"  height="300px" :counter-danger.sync="counterDanger" /> -->
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <vs-button block @click="registerTicket()">Create Event</vs-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="col-md-12 mt-3" id="ticketView">
                            <div class="card mt-5">
                                <div class="card-body" v-if="showTable">
                                    <h3 class="mt-3 mb-3">Ticket Data - <span><small><a
                                                    class="btn btn-dark text-white click text-center"
                                                    @click="resetTable()"><i class="fas fa-sync-alt"></i> Reset search
                                                    table</a></small></span> </h3>
                                    <vs-table>
                                        <template #thead>
                                            <vs-tr>
                                                <vs-th sort-key="ticketId">
                                                    Ticket ID
                                                </vs-th>
                                                <vs-th sort-key="sentDate">
                                                    Date
                                                </vs-th>

                                                <vs-th sort-key="companyName">
                                                    Company
                                                </vs-th>

                                                <vs-th sort-key="jobName">
                                                    Job
                                                </vs-th>

                                                <vs-th sort-key="sn">
                                                    S/N
                                                </vs-th>

                                                <vs-th sort-key="statusLabel">
                                                    Status
                                                </vs-th>
                                                <vs-th class="tableInfo" sort-key="user">
                                                    By
                                                </vs-th>
                                                <vs-th>
                                                    Operations
                                                </vs-th>
                                            </vs-tr>
                                        </template>
                                        <template #tbody>
                                            <vs-tr :key="indextr" v-for="(tr, indextr) in tickets">
                                                <vs-td :data="tickets[indextr].ticketId" class="text-center">
                                                    <a class="click ticketLink"
                                                        @click="seeDetails(tickets[indextr])">{{tickets[indextr].ticketId}}</a>
                                                </vs-td>


                                                <vs-td
                                                    :data="moment(tickets[indextr].sentDate).format('YYYY-MM-DD HH:mm:ss')">
                                                    {{ moment(tickets[indextr].sentDate).format('YYYY-MM-DD HH:mm:ss')
                                                    }}
                                                </vs-td>

                                                <vs-td :data="tickets[indextr].companyName">
                                                    {{tickets[indextr].companyName}}
                                                </vs-td>

                                                <vs-td :data="tickets[indextr].jobName">
                                                    {{tickets[indextr].jobName}}
                                                </vs-td>

                                                <vs-td :data="tickets[indextr].sn">
                                                    <vs-button
                                                        @click="sendRepairs(tickets[indextr].sn,tickets[indextr].ticketId,tickets[indextr].status,moment(tickets[indextr].sentDate).format('YYYY-MM-DD HH:mm:ss'),tickets[indextr].jobName,tickets[indextr].sentNotes)">
                                                        🔨{{tickets[indextr].sn}}</vs-button>
                                                </vs-td>


                                                <vs-td :data="tickets[indextr].status">
                                                    <template v-if="tickets[indextr].status==1">
                                                        <span class="gray">🚀 opened</span>
                                                    </template>
                                                    <template v-if="tickets[indextr].status==2">
                                                        <span class="purple">🧰 in repair</span>
                                                    </template>
                                                    <template v-if="tickets[indextr].status==3">
                                                        <span class="green">✅ closed</span>

                                                    </template>
                                                </vs-td>

                                                <vs-td class="tableInfo" :data="tickets[indextr].user">
                                                    {{tickets[indextr].user}}
                                                </vs-td>


                                                <vs-td>
                                                    <button class="btn btn-block btn-sm btn-dark"
                                                        @click="getPic(tickets[indextr].ticketId)"> <i
                                                            class="fa fa-qrcode"></i> Print Tag</button>
                                                    <button class="btn btn-block btn-sm btn-success"
                                                        @click="addTrack(tickets[indextr].ticketId)"> <i
                                                            class="fa fa-plus"></i> Add Event</button>
                                                    <button class="btn btn-block btn-sm btn-danger"
                                                        @click="delTicket(tickets[indextr].ticketId)"
                                                        v-if="remEmail=='dianar@ag-tronix.com' || remEmail=='lorenzo.are@gmail.com' || remEmail=='scottf@ag-tronix.com' || remEmail=='jamier@ag-tronix.com'">
                                                        <i class="fa fa-trash"></i> Delete</button>
                                                </vs-td>

                                            </vs-tr>
                                        </template>
                                    </vs-table>
                                    <div class="text-center mt-2">
                                        <!-- <vs-pagination :total="totalTickets" v-model="currentx"></vs-pagination> -->
                                        <v-pagination v-model="currentx" :page-count="totalTickets"></v-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>




        <vs-dialog v-model="openCamera">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h3>Scan a Qr</h3>
                        <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit" v-if="openCamera" />
                    </div>
                </div>
            </div>
        </vs-dialog>

        <vs-dialog v-model="pDetails">
            <div class="container-fluid m-3" id="modalDetails">
                <div class="row" v-if="displayMessages2">
                    <div class="col-md-12 text-center mt-5 mb-5">
                        <transition name="fade">
                            <span class="alert-danger" v-if="showErrorMessage2">{{errorMessage2}}</span>
                            <span class="alert-success" v-if="showSuccessMessage2">{{successMessage2}} </span>
                            <span class="alert-info" v-if="showInfoMessage2">{{successInfo2}}</span>
                        </transition>
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-5">
                        <h3>Ticket #{{selectedTicket}}</h3>
                        <ul class="list-group">
                            <li class="list-group-item ">
                                <strong>Company Name:</strong> {{selectedObject.companyName}}
                            </li>
                            <li class="list-group-item ">
                                <strong>Job Name</strong> {{selectedObject.jobName}}
                            </li>
                            <li class="list-group-item ">
                                <strong>Created Date</strong> {{selectedObject.sentDate}}
                            </li>
                            <li class="list-group-item ">
                                <strong>Received Date</strong> {{selectedObject.receivedDate}}
                            </li>
                            <li class="list-group-item ">
                                <strong>S/N</strong> {{selectedObject.sn}}
                            </li>
                            <li class="list-group-item ">
                                <strong>Sent notes</strong> {{selectedObject.sentNotes}}
                            </li>
                            <li class="list-group-item ">
                                <strong>Created by</strong> {{selectedObject.user}}
                            </li>
                        </ul>
                        <br>


                        <hr />

                        <h4 class="text-muted">Movements</h4>

                        <div class="form-group">
                            <label for="">Company name</label>
                            <input type="text" class="form-control form-control-sm" placeholder="Company name"
                                v-model="companyNameChange">
                        </div>
                        <div class="form-group">
                            <label for="">Job name</label>
                            <input type="text" class="form-control form-control-sm" placeholder="Job name"
                                v-model="jobNameChange">
                        </div>
                        <div class="form-group">
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input type="radio" class="form-check-input" name="optradio"
                                        v-model="statusTicketChange" value="1">Opened
                                </label>
                            </div>
                            <!-- <div class="form-check">
                                <label class="form-check-label">
                                    <input type="radio" class="form-check-input" name="optradio"
                                        v-model="statusTicketChange" value="2">In repair
                                </label>
                            </div> -->
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input type="radio" class="form-check-input" name="optradio"
                                        v-model="statusTicketChange" value="3">Closed
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <vs-button block @click="createChange()">Save changes</vs-button>
                        </div>



                    </div>

                    <div class="col-md-7">

                        <h3>Add event</h3>
                        <div class="form-group">
                            <label for="">Event date</label>
                            <datetime input-class="form-control form-control-sm" type="datetime"
                                format="yyyy-MM-dd HH:mm" :value-zone="timeZ" v-model="eventDate"></datetime>
                        </div>
                        <div class="form-group">
                            <label for="">PO/INV</label>
                            <input type="text" class="form-control form-control-sm" v-model="po">
                        </div>
                        <div class="form-group">
                            <label for="">Aditional notes <small class="text-muted">You can describe details of event
                                    date here.</small></label>
                            <textarea class="form-control form-control-sm" maxlength="180" cols="30" rows="3"
                                v-model="aditionalNotes"></textarea>
                        </div>
                        <div class="form-group">
                            <vs-button block @click="addDetails()">Add Event</vs-button>
                        </div>

                        <br>

                        <h4 class="text-muted">Tracking history</h4>
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Event date</th>
                                    <th>PO/INV</th>
                                    <th>Details</th>
                                    <th>User</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in trackHistory" :key="index">
                                    <td>{{item.eventDate}}</td>
                                    <td>{{item.po}}</td>
                                    <td>{{item.details}}</td>
                                    <td>{{item.user}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
        </vs-dialog>

        <vs-dialog title="Add event" v-model="ptrack">
            <div class="container addTrackView">
                <div class="row">
                    <div class="col-md-12">
                        <h3>Ticket #{{selectedTicket}}</h3>
                        <div class="form-group">
                            <label for="">Event date</label>
                            <datetime input-class="form-control form-control-sm" type="datetime"
                                format="yyyy-MM-dd HH:mm" :value-zone="timeZ" v-model="eventDate"></datetime>
                        </div>
                        <div class="form-group">
                            <label for="">PO/INV</label>
                            <input type="text" class="form-control form-control-sm" v-model="po">
                        </div>
                        <div class="form-group">
                            <label for="">Aditional notes <small class="text-muted">You can describe details of event
                                    date here.</small></label>
                            <textarea class="form-control form-control-sm" maxlength="180" cols="30" rows="10"
                                v-model="aditionalNotes"></textarea>
                        </div>
                        <div class="form-group">
                            <vs-button block @click="addDetails2()">
                                Add Event
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vs-dialog>


        <vs-dialog v-model="pDelTicket">
            <div class="container dDel">

                <div class="row">
                    <div class="col-md-12 mt-3">
                        <h4 class="not-margin"> 🗑️Delete <b>ticket</b></h4>
                        <hr />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p>Are you sure you want to delete all data associated with ticket #{{selectedTicket}}? <br>
                            <small>Associated data included <strong>aditional info will be deleted.</strong></small>
                        </p>
                    </div>

                </div>

                <vs-button block @click="confirmDel()">
                    Yes, delete it!
                </vs-button>
                <vs-button danger block @click="pDelTicket=false">
                    Cancel
                </vs-button>
            </div>
        </vs-dialog>




    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
    import { firebaseApp } from "../fb";
    import Navbar from "@/components/Navbar.vue";
    import Sidebar from "@/components/Sidebar.vue";
    import Mobilebar from "@/components/Mobilebar.vue";
    import validator from "validator";
    import axios from 'axios';
    import { Datetime } from 'vue-datetime';
    import Multiselect from 'vue-multiselect'
    import { QrcodeStream } from 'vue-qrcode-reader';
    import io from 'socket.io-client';
    import vPagination from 'vue-plain-pagination'
    import Dark from "@/components/Dark.vue";
    export default {
        name: 'Home',
        components: {
            Sidebar,
            Mobilebar,
            datetime: Datetime,
            Multiselect: Multiselect,
            QrcodeStream,
            Navbar,
            vPagination,
            Dark
        },
        data() {
            return {
                camera: 'auto',
                showTable: false,
                displayMessages2: false,
                showErrorMessage2: false,
                showSuccessMessage2: false,
                showInfoMessage2: false,
                modalManualRecordEdit: false,
                modalManualRecord: false,
                displayMessages: false,
                showErrorMessage: false,
                errorMessage: null,
                showSuccessMessage: false,
                successMessage: null,
                showInfoMessage: false,
                successInfo: null,
                showBottomBar: true,
                showMobile: false,
                showLogo: false,
                showNav: false,
                sentDate: '',
                receivedDate: '',
                sentNotes: '',
                sn: '',
                po: '',
                counterDanger: false,
                companyName: '',
                jobName: '',
                timeZ: Intl.DateTimeFormat().resolvedOptions().timeZone,

                tickets: [],
                token: '8317829b00b26102bbd95f89401049f0',
                totalEvents: 0,
                totalRepair: 0,
                totalClosed: 0,
                ptrack: false,
                selectedTicket: 0,
                selectedObject: [],
                trackHistory: [],
                eventDate: '',
                counterDanger2: false,
                aditionalNotes: '',

                pDelTicket: false,

                pDetails: false,
                destroyed: false,
                result: '',
                openCamera: false,
                device: '',
                pCamera: false,
                socket: '',


                sCompany: 'x',
                sCompanies: [],
                sJobs: [],
                sPo: '',
                sJob: 'x',
                sSn: '',

                statusTicketChange: 0,
                companyNameChange: '',
                jobNameChange: '',

                url: '',
                apiNickname: '',
                user: '',
                name: '',
                apiObject: [],
                apiObject2: [],
                apiObjectLength: 0,
                totalUsers: 0,
                editName: '',
                editApi: '',
                editIndex: '',
                dbname: '',
                dbpass: '',
                dbuser: '',
                nName: '',
                nEmail: '',
                nPass: '',
                lvl: 0,
                nConfirm: '',
                nDbName: '',
                nDbUser: '',
                nDbPass: '',
                eDbName: '',
                eDbUser: '',
                eDbPass: '',
                eLvl: 0,
                eIndex: '',
                eStatus: false,
                liveApi: 0,
                seeUid: '',
                seeObj: [],
                messageCopy: '',
                showCopy: false,
                currentx: 1,
                totalTickets: 0,
                level: 0,
                remEmail: null
            };
        },

        created() {
            var vm = this
            console.log('Creado')
            vm.socket = io.connect('https://quantumsync.org:3003/');
            vm.socket.on("openTicket", (data) => {
                console.log('RECEIVED OPEN TICKET')
                console.log(data); // world
                let obj = JSON.parse(data)
                console.log(obj.ticket, obj.uid, obj.device)
                if (obj) {
                    vm.seeDetailScan(obj.ticket, obj.uid, obj.device)
                }

            });
        },

        mounted() {
            var vm = this


            vm.getTicket(1)
            vm.isMobile()
            vm.getTotalEvents()
            vm.getCompanies()


            //setTimeout(() => {
            // vm.socket =  io.connect('https://quantumsync.org:3003/');
            // vm.socket.on ('openTicket', function (data) {
            //     console.log ('SOCKET DATA');
            //     console.log (data);
            //     vm.seeDetailScan(data.ticket, data.uid, data.device)
            // });
            // vm.socket.on ('', function (data) {
            //     console.log ('SOCKET DATA');
            //     console.log (data)
            //     var algo = JSON.stringify()
            // });
            // }, 4000);





            firebaseApp.auth().onAuthStateChanged(function (user) {
                if (user) {
                    firebaseApp.database().ref(`users/${user.uid}`)
                        .orderByChild('email')
                        .once('value', function (snapshot) {
                            snapshot.forEach(function (child) {
                                // const element  = child.val().lvl;
                                const element = child.val();
                                if (element.lvl == 1) {
                                    vm.$router.push('/Main');
                                } else {
                                    vm.remEmail = user.email
                                    vm.getInitialData();
                                }
                            });
                        })
                }
            });

        },
        watch: {
            currentx: function (e) {
                this.currentx = e
                this.getTicket(this.currentx)
            }
        },
        methods: {

            closeMobileBar() {
                // this.showMobile=false
            },

            displaySuccess2(message) {
                var vm = this
                vm.displayMessages2 = true
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (vm.showSuccessMessage2) {
                    vm.showSuccessMessage2 = false
                }
                vm.showSuccessMessage2 = true
                vm.successMessage2 = `✅${message}`
                setTimeout(() => {
                    vm.showSuccessMessage2 = false
                    vm.displayMessages2 = false
                }, 3000);
            },


            displayError2(error) {
                var vm = this
                vm.displayMessages2 = true
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (vm.showErrorMessage2) {
                    vm.showErrorMessage2 = false
                }
                vm.showErrorMessage2 = true
                vm.errorMessage2 = `❌${error}`
                setTimeout(() => {
                    vm.showErrorMessage2 = false
                    vm.displayMessages2 = false
                }, 3000);
            },

            displayError(error) {
                var vm = this
                vm.displayMessages = true
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (vm.showErrorMessage) {
                    vm.showErrorMessage = false
                }
                vm.showErrorMessage = true
                vm.errorMessage = `❌${error}`
                setTimeout(() => {
                    vm.showErrorMessage = false
                    vm.displayMessages = false
                }, 3000);
            },

            displaySuccess(message) {
                var vm = this
                vm.displayMessages = true
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (vm.showSuccessMessage) {
                    vm.showSuccessMessage = false
                }
                vm.showSuccessMessage = true
                vm.successMessage = `✅${message}`
                setTimeout(() => {
                    vm.showSuccessMessage = false
                    vm.displayMessages = false
                }, 3000);
            },


            toggleMenu() {
                this.showBottomBar = !this.showBottomBar
                if (this.showBottomBar) {
                    this.showLogo = false
                } else {
                    this.showLogo = true
                }
            },
            toggleMobile() {
                // this.showMobile = !this.showMobile
                this.$router.push('/mobile');
            },

            sendRepairs(sn, ticketId, status, sendDate, jobName, sentNotes) {
                console.log(sn, jobName, encodeURIComponent(sentNotes))
                this.$router.push(`/repairs/${sn}/${ticketId}/${status}/${sendDate}/${jobName}/${encodeURIComponent(sentNotes)}`);
            },

            async filterBy(type) {
                console.log(type)
                var vm = this
                var status = 1
                switch (type) {
                    case "opened":
                        status = 1;
                        break;
                    case "inRepair":
                        status = 2;
                        break;
                    case "closed":
                        status = 3;
                        break;

                    default:
                        break;
                }

                const bodyParameters = {
                    status: status
                };



                await axios.post(`https://quantumsync.org/api-agt/index.php?searchFilter=true`, bodyParameters)
                    .then(function (response) {
                        vm.tickets = []
                        document.getElementById("ticketView").scrollIntoView();
                        console.log(response.data)
                        vm.totalTickets = response.data[0].totalRows
                        vm.getTotalEvents()
                        response.data.forEach(function (element, i) {
                            if (i > 0) {
                                switch (element.status) {
                                    case "1":
                                        element.statusLabel = 'Opened';
                                        break;
                                    case "2":
                                        element.statusLabel = 'In repair';
                                        break;
                                    case "3":
                                        element.statusLabel = 'Closed';
                                        break;

                                    default:
                                        break;
                                }
                                vm.tickets.push(element)
                            }
                        });

                        return;
                    })
                    .catch(function (error) {
                        vm.displayError(error);
                    })

            },

            async verifySerialNumber() {
                var vm = this
                if (vm.sn.length >= 0 && vm.sn.length >= 10) {
                    console.log(vm.sn)
                    await axios.post('https://quantumsync.org:3000/api/verifySerialNumber', {
                        sn: vm.sn
                    })
                        .then(function (response) {
                            let data = response.data
                            console.log(data[0].total)
                            if (data[0]) {
                                if (parseInt(data[0].total) > 0) {
                                    vm.displayError("You have this serial number already used, please verify it in search table.");
                                    vm.sn = ""
                                    return
                                }
                            }
                        })
                        .catch(function (error) {
                            vm.displayError(error);
                        })
                }
            },


            resetTable() {
                this.currentx = 1
                this.getTicket(1)
                this.displaySuccess("The table has been reset");
                return;
            },


            async search() {
                var vm = this
                var sPo = "x"
                var sSn = "x"
                if (vm.sPo.length != 0) {
                    sPo = vm.sPo
                }
                if (vm.sSn.length != 0) {
                    sSn = vm.sSn
                }

                if (sSn == "x" && sPo == "x" && vm.sCompany == "x" && vm.sJob == "x") {
                    vm.displayError("Please select or type at least one value")
                    return
                }


                const bodyParameters = {
                    sPo: sPo,
                    sSn: sSn,
                    sCompany: vm.sCompany,
                    sJob: vm.sJob
                };


                await axios.post(`https://quantumsync.org/api-agt/index.php?search=true`, bodyParameters)
                    .then(function (response) {
                        vm.tickets = []
                        vm.totalTickets = response.data[0].totalRows
                        vm.getTotalEvents()
                        response.data.forEach(function (element, i) {
                            if (i > 0) {
                                switch (element.status) {
                                    case "1":
                                        element.statusLabel = 'Opened';
                                        break;
                                    case "2":
                                        element.statusLabel = 'In repair';
                                        break;
                                    case "3":
                                        element.statusLabel = 'Closed';
                                        break;

                                    default:
                                        break;
                                }
                                vm.tickets.push(element)
                            }
                        });
                        vm.displaySuccess("Data was found correctly")
                        return;
                    })
                    .catch(function (error) {
                        vm.displayError(error)
                    })


            },

            async getCompanies() {
                var vm = this
                await axios.get(`https://quantumsync.org/api-agt/index.php?getCompanies=true`)
                    .then(function (response) {
                        console.log(response.data)
                        let data = response.data

                        data.forEach(element => {
                            if (element.id == 0) {
                                vm.sCompanies.push(element.name)
                            }
                            if (element.id == 1) {
                                vm.sJobs.push(element.name)
                            }
                        });
                    })
                    .catch(function (error) {
                        vm.displayError(error);
                    })
            },


            async createChange() {
                const vm = this

                var user = localStorage.getItem('ufb')
                user = JSON.parse(user)


                if (vm.companyNameChange.length == 0) {
                    var companyNameChange = 'lorenzoarellano'
                } else {
                    var companyNameChange = vm.companyNameChange
                }

                if (vm.jobNameChange.length == 0) {
                    var jobNameChange = 'lorenzoarellano'
                } else {
                    var jobNameChange = vm.jobNameChange
                }

                const bodyParameters = {
                    tickeId: vm.selectedTicket,
                    companyNameChange: companyNameChange,
                    jobNameChange: jobNameChange,
                    statusTicketChange: vm.statusTicketChange,
                    user: user.email
                };

                const messageSms = `From: Inventory, ${user.displayName} has closed a work order with ticket: ${vm.selectedTicket}`

                console.log(bodyParameters)

                await axios.post(
                    "https://quantumsync.org/api-agt/index.php?makeChanges=true",
                    bodyParameters
                ).then((response) => {
                    if (response.data) {
                        console.log(response.data)
                        vm.pDetails = false
                        vm.getTicket(1)
                        vm.getTotalEvents()
                        vm.displaySuccess("Data changed successfully");
                        if (parseInt(vm.statusTicketChange) == 3) {
                            vm.sendSMS(messageSms)
                        }
                        return;
                    }
                }).catch((err) => {
                    console.log(err)
                    vm.displayError(err);
                    return;
                });


            },


            async sendSMS(message) {
                const bodyParameters = {
                    message: message
                };
                await axios.post('https://quantumsync.org:3003/api/sendSms',
                    bodyParameters
                ).then((response) => {
                    if (response.data) {
                        console.log(response.data)
                        return;
                    }
                }).catch((err) => {
                    console.log(err)
                    vm.displayError(err);
                    return;
                });
            },

            openCam() {
                console.log('open Camera')
                // if(this.device=='phone'){
                // navigator.vibrate(500);
                this.openCamera = true
                // }else{
                //     this.sendNotify("Error", "You can't use PC to scan something", "danger", "highlight_off");
                //     this.openCamera=false
                // }

            },

            async getSingleTicket(ticket) {
                var vm = this
                const bodyParameters = {
                    tickeId: ticket,
                };
                await axios.post(`https://quantumsync.org/api-agt/index.php?getsingleTicket=true`, bodyParameters)
                    .then(function (response) {
                        console.log('SINGLE TICKET:::::::::::::::::')
                        console.log(response.data)
                        vm.selectedObject = response.data[0]
                        vm.statusTicketChange = vm.selectedObject.status

                    })
                    .catch(function (error) {
                        vm.displayError(error);
                    })
            },

            isMobile() {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    this.device = 'phone'
                    return true
                } else {
                    this.device = 'desk'
                    return false
                }
            },

            turnCameraOn() {
                this.camera = 'auto'
            },

            turnCameraOff() {
                this.camera = 'off'
            },

            timeout(ms) {
                return new Promise(resolve => {
                    window.setTimeout(resolve, ms)
                })
            },


            async onDecode(result) {

                console.log(this.device)
                var vm = this

                var user = localStorage.getItem('ufb')
                user = JSON.parse(user)
                console.log(user)

                // if(this.device=='phone'){
                // navigator.vibrate(500);
                this.result = result
                console.log('Scanned....................', this.result)
                this.socket.emit('send_ticket', { uid: user.uid, ticket: this.result, device: this.device })

                this.openCamera = false

                this.turnCameraOff()
                await this.timeout(1000)
                this.turnCameraOn()






                // this.seeDetailScan(this.result)
                // }else{
                //     this.sendNotify("Error", "You can't use PC to scan something", "danger", "highlight_off");
                //     this.openCamera=false
                // }

            },
            async onInit(promise) {
                var vm = this
                try {
                    vm.socket = io.connect('https://quantumsync.org:3003/');
                    console.log(vm.socket)
                    vm.socket.on("openTicket", (data) => {
                        console.log('RECEIVED OPEN TICKET')
                        console.log(data); // world
                        let obj = JSON.parse(data)
                        console.log(obj.ticket, obj.uid, obj.device)
                        if (obj) {
                            vm.seeDetailScan(obj.ticket, obj.uid, obj.device)
                        }

                    });
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.error = "ERROR: you need to grant camera access permisson"
                    } else if (error.name === 'NotFoundError') {
                        this.error = "ERROR: no camera on this device"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "ERROR: secure context required (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "ERROR: is the camera already in use?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "ERROR: installed cameras are not suitable"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "ERROR: Stream API is not supported in this browser"
                    }
                }


            },

            async getPic(ticket) {
                var vm = this
                console.log(`https://quantumsync.org:3003/tag/${ticket}`)
                window.location.assign(`https://quantumsync.org:3003/tag/${ticket}`);
                const loading = vm.$vs.loading()
                setTimeout(() => {
                    loading.close()
                }, 3000)

                return
                await axios.get(`https://quantumsync.org:3003/tag/${ticket}`)
                    .then(function (response) {
                        window.location.assign(`https://quantumsync.org:3003/tag/${ticket}`);
                        vm.$vs.loading.close()
                    })
                    .catch(function (error) {
                        vm.displayError(error);
                    })
            },


            async seeDetails(tr) {
                var vm = this
                this.selectedObject = tr
                this.selectedTicket = tr.ticketId
                this.pDetails = true
                this.statusTicketChange = tr.status
                window.scrollTo({ top: 0, behavior: 'smooth' });

                const bodyParameters = {
                    tickeId: tr.ticketId,
                };
                await axios.post(
                    "https://quantumsync.org/api-agt/index.php?getDetails=true",
                    bodyParameters
                ).then((response) => {
                    if (response.data) {
                        console.log(response.data)
                        vm.trackHistory = response.data
                        return;
                    }
                }).catch((err) => {
                    console.log(err)
                    vm.displayError(err);
                    return;
                });

            },

            seeDetailScan(ticket, uid, device) {
                var vm = this

                var user = localStorage.getItem('ufb')
                user = JSON.parse(user)


                if (user.uid == uid) {

                    // if(device=='desk'){
                    this.openCamera = false
                    this.getSingleTicket(ticket)
                    this.selectedTicket = ticket
                    console.log('details')

                    setTimeout(() => {

                        this.pDetails = true
                    }, 1000);


                    const bodyParameters = {
                        tickeId: ticket,
                    };
                    axios.post(
                        "https://quantumsync.org/api-agt/index.php?getDetails=true",
                        bodyParameters
                    ).then((response) => {
                        if (response.data) {
                            console.log(response.data)
                            vm.trackHistory = response.data
                            return;
                        }
                    }).catch((err) => {
                        console.log(err)
                        vm.displayError(err);
                        return;
                    });
                    // }else{

                    // }
                }



            },


            addDetails() {
                const vm = this
                if (vm.eventDate.length == 0) {
                    vm.displayError2("Event date is empty");
                    return;
                }
                var po = '--'
                if (vm.po.length > 0) {
                    po = vm.po
                }
                var user = localStorage.getItem('ufb')
                user = JSON.parse(user)
                var regex = /^[A-Za-z0-9._\-@#$%&, ]+$/
                var isValid = regex.test(vm.aditionalNotes);
                if (vm.aditionalNotes.length == 0) {
                    vm.displayError2("Aditional notes is empty");
                    return;
                }
                const bodyParameters = {
                    tickeId: vm.selectedTicket,
                    eventDate: vm.eventDate,
                    details: vm.aditionalNotes,
                    user: user.email,
                    po: po
                };
                axios.post(
                    "https://quantumsync.org/api-agt/index.php?addDetails=true",
                    bodyParameters
                ).then((response) => {
                    if (response.data) {
                        vm.displaySuccess2("Details added successfully");
                        vm.selectedTicket = ''
                        vm.eventDate = ''
                        vm.aditionalNotes = ''
                        vm.sentDate = ''
                        vm.po = ''
                        vm.ptrack = false
                        vm.getTicket(1)
                        vm.getTotalEvents()
                        vm.seeDetails(vm.selectedObject)
                        return;
                    }
                }).catch((err) => {
                    console.log(err)
                    vm.displayError2(err);
                    return;
                });
            },

            addDetails2() {
                const vm = this
                if (vm.eventDate.length == 0) {
                    vm.displayError("Event date is empty");
                    return;
                }
                var po = '--'
                if (vm.po.length > 0) {
                    po = vm.po
                }
                var user = localStorage.getItem('ufb')
                user = JSON.parse(user)
                var regex = /^[A-Za-z0-9._\-@#$%&, ]+$/
                var isValid = regex.test(vm.aditionalNotes);
                if (vm.aditionalNotes.length == 0) {
                    vm.displayError("Aditional notes is empty");
                    return;
                }
                const bodyParameters = {
                    tickeId: vm.selectedTicket,
                    eventDate: vm.eventDate,
                    details: vm.aditionalNotes,
                    user: user.email,
                    po: po
                };
                axios.post(
                    "https://quantumsync.org/api-agt/index.php?addDetails=true",
                    bodyParameters
                ).then((response) => {
                    if (response.data) {
                        vm.displaySuccess("Details added successfully");
                        vm.selectedTicket = ''
                        vm.eventDate = ''
                        vm.aditionalNotes = ''
                        vm.sentDate = ''
                        vm.po = ''
                        vm.ptrack = false
                        vm.getTicket(1)
                        vm.getTotalEvents()
                        return;
                    }
                }).catch((err) => {
                    console.log(err)
                    vm.displayError(err);
                    return;
                });
            },

            addTrack(ticket) {
                this.selectedTicket = ticket
                this.ptrack = true

                setTimeout(() => {
                    var targetElm = document.querySelector('.addTrackView')
                    targetElm.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" })
                }, 100);

            },

            confirmDel() {
                var vm = this
                const bodyParameters = {
                    tickeId: vm.selectedTicket
                };
                axios.post(
                    "https://quantumsync.org/api-agt/index.php?delTicket=true",
                    bodyParameters
                ).then((response) => {
                    if (response.data) {
                        vm.displaySuccess("Ticket deleted successfully");
                        vm.selectedTicket = ''
                        vm.pDelTicket = false
                        vm.getTicket(1)
                        vm.getTotalEvents()
                        return;
                    }
                }).catch((err) => {
                    console.log(err)
                    vm.displayError(err);
                    return;
                });
            },


            delTicket(ticket) {
                this.selectedTicket = ticket
                this.pDelTicket = true
                setTimeout(() => {
                    var targetElm = document.querySelector('.dDel')
                    targetElm.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" })
                }, 100);
            },

            registerTicket() {
                const vm = this

                var user = localStorage.getItem('ufb')
                user = JSON.parse(user)

                if (vm.companyName.length == 0) {
                    vm.displayError("Company name is empty")
                    return;
                }
                var regex = /^[A-Za-z0-9._\-@#$%&, ]+$/
                var isValid = regex.test(vm.companyName);
                if (!isValid) {
                    vm.companyName = ''
                    vm.displayError("Company name contains special characters")
                    return;
                }
                if (vm.jobName.length == 0) {
                    vm.displayError("Job name is empty")
                    return;
                }
                var isValidJob = regex.test(vm.jobName);
                if (!isValidJob) {
                    vm.jobName = ''
                    vm.displayError("Job name contains special characters")
                    return;
                }

                if (vm.sentDate.length == 0) {
                    vm.displayError("Date is empty")
                    return;
                }

                if (vm.receivedDate.length == 0) {
                    vm.displayError("Received date is empty")
                    return;
                }

                if (vm.sn.length == 0) {
                    vm.displayError("S/N is empty")
                    return;
                }



                if (vm.sentNotes.length == 0) {
                    vm.displayError("Sent notes is empty")
                    return;
                }
                //  var isValidSentNotes = regex.test(vm.sentNotes);
                // if (!isValidSentNotes) {
                //     vm.sentNotes= ''
                //     vm.sendNotify("Error", "Sent notes contains special characters", "danger", "highlight_off");
                //     return;
                // } 



                const bodyParameters = {
                    companyName: vm.companyName,
                    jobName: vm.jobName,
                    sentDate: vm.sentDate,
                    receivedDate: vm.receivedDate,
                    sn: vm.sn,
                    user: user.email,
                    sentNotes: vm.sentNotes
                };
                axios.post(
                    "https://quantumsync.org/api-agt/index.php?registerTicket=true",
                    bodyParameters
                ).then((response) => {
                    if (response.data) {
                        vm.displaySuccess("Ticket was created successfully");
                        vm.companyName = ''
                        vm.jobName = ''
                        vm.sentDate = ''
                        vm.sentNotes = ''
                        vm.getTicket(1)
                        return;
                    }
                }).catch((err) => {
                    console.log(err)
                });

            },


            getTotalEvents() {
                var vm = this
                axios.get('https://quantumsync.org/api-agt/index.php?getTotalEvents=true')
                    .then(function (response) {
                        console.log('-----------------')
                        console.log(response.data)
                        vm.totalEvents = response.data[0].opened
                        vm.totalRepair = response.data[1].repair
                        vm.totalClosed = response.data[2].closed
                    })
                    .catch(function (error) {
                        console.log(error)
                        vm.displayError(`Something went wrong ${error}`);
                        return;
                    })
            },

            getTicket(page) {
                console.log('entra 1')
                var vm = this
                vm.tickets = []
                const bodyParameters = {
                    page: page
                };
                // axios.post('http://ec2-3-88-19-50.compute-1.amazonaws.com:3000/api/getTicket',{
                axios.post('https://quantumsync.org/api-agt/index.php?getTickets=true',
                    bodyParameters
                )
                    .then(function (response) {
                        setTimeout(() => {
                            vm.showTable = true
                        }, 200);
                        vm.totalTickets = response.data[0].totalRows
                        vm.getTotalEvents()
                        response.data.forEach(function (element, i) {
                            if (i > 0) {
                                switch (element.status) {
                                    case "1":
                                        element.statusLabel = 'Opened';
                                        break;
                                    case "2":
                                        element.statusLabel = 'In repair';
                                        break;
                                    case "3":
                                        element.statusLabel = 'Closed';
                                        break;

                                    default:
                                        break;
                                }
                                vm.tickets.push(element)
                            }
                        });
                        return;
                    })
                    .catch(function (error) {
                        console.log(error)
                        vm.displayError(`Something went wrong ${error}`);
                        return;
                    })
            },

            toggleBodyClass(addRemoveClass, className) {
                const el = document.body;

                if (addRemoveClass === 'addClass') {
                    el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }
            },


            dbConfig() {
                this.$refs.initModal.open()
            },

            getInitialData() {
                var vm = this

                firebaseApp.auth().onAuthStateChanged(function (user) {
                    if (!user) {
                        vm.$router.push('/');
                    } else {
                        vm.user = user.uid
                        firebaseApp.database().ref('users/' + user.uid).once("value", function (snapshot) {
                            var data = snapshot.val();
                            vm.level = data.lvl
                            vm.name = data.name
                            vm.dbname = data.dbname
                            vm.dbuser = data.dbuser
                            vm.dbpass = data.dbpass
                            if (data.api) {
                                vm.apiObject = data.api
                                vm.apiObjectLength = vm.apiObject.length
                            }
                        }, function (errorObject) {
                            vm.displayError(`Something went wrong ${errorObject}`)
                            return;
                        });
                    }
                });
            },


            openLoadingBackground() {
                this.$vs.loading({ background: 'rgb(0,0,0,0.3)', color: 'rgb(255, 255, 255)' })
                setTimeout(() => {
                    this.$vs.loading.close()
                    this.loading = true
                }, 1000);
            },

            openLoadingBackground2() {
                this.$vs.loading({ background: 'rgb(0,0,0,0.3)', color: 'rgb(255, 255, 255)' })
            },

            logOut() {
                this.loading = false
                firebaseApp.auth().signOut()
            },
            sendNotify(title, text, color, icon) {
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: color,
                    icon: icon
                });
                /*highlight_off error*/
            },
        },
        props: {
            msg: String
        }
    }
</script>

<style>
    .collapse {
        display: hide !important;
    }

    .custom-bg {
        /* background: url('~@/assets/wall.jpg') !important; */
        background: linear-gradient(56deg, rgba(226, 255, 253, 1) 0%, rgba(255, 210, 215, 1) 100%) !important;

        -webkit-background-size: cover !important;
        -moz-background-size: cover !important;
        -o-background-size: cover !important;
        background-size: cover !important;
        background-position: center center !important;
        background-repeat: no-repeat !important;
        background-attachment: fixed !important;
    }

    .vs-pagination--ul {
        margin-bottom: 0px !important;
    }

    .vs-table--search {
        margin-right: 10px !important;
    }
</style>